import { Button, Divider, TextField, Box, FormControl, Grid, Stack, InputAdornment, Dialog, DialogTitle, DialogActions, Backdrop, DialogContent } from "@mui/material";
import classes from "../ParticipanteClasess.css";
import * as React from 'react';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import { useMediaQuery } from '@mui/material';
import 'dayjs/locale/es'; // Importa el archivo de localización para español


export default function AvalPrecargado({ identidad, nombres, apellidos, nacimiento, profesion, vivienda, barrio, calle, ave, casa, ciudad,
    departamento, estado, referenciadomicilio, fijo, movil, correo, dependencia, ramo, telefonolaboral, barriolaboral, avenidalaboral,
    callelaboral, casalaboral, ciudadlaboral, departamentolaboral, sueldomensual, otrosingresos, sueldoneto, puesto, tiempolaborarA,
    tiempolaborarM, icono, handleDescargar, openAval1, closeAval1, pdfUrlAval1 }) {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil


    return (
        <>

            <Box marginTop={3}>
                <h3>IDENTIDAD DEL AVAL 1 EN FORMATO {isMobile ? "IMÁGENES" : "PDF"}</h3>
                <Box display="flex" alignItems="center" justifyContent="center">
                    <Box
                        style={{
                            padding: '50px',
                            width: isMobile ? '300px' : '700px',
                            textAlign: 'center',
                            borderColor: 'var(--color-gray-500)',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <img src={icono} alt="Download PDF Icon" style={{ width: 75, height: 77, color: 'var(--color-gray-500)' }} />
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleDescargar}
                            color="primary"
                            style={{ marginTop: '10px', backgroundColor: 'var(--color-surface-muted)' }}
                        >
                            Ver Archivo {isMobile ? "Imágenes" : "PDF"}
                        </Button>
                        <p>Haz clic en el botón para visualizar la identidad del aval 1 en {isMobile ? "imágenes" : "PDF"}</p>
                        <Backdrop open={openAval1} onClick={closeAval1} style={{ zIndex: 1 }}>
                            <Dialog
                                open={openAval1}
                                onClose={closeAval1}
                                maxWidth="md"
                                fullWidth
                            >
                                <DialogTitle textAlign={'center'}>Identidad Del Aval 1</DialogTitle>
                                <DialogContent>
                                    {isMobile ? (
                                        // Mostrar imágenes si es móvil
                                        pdfUrlAval1 && pdfUrlAval1.map((base64Image, index) => (
                                            <img key={index} src={`data:image/png;base64,${base64Image}`} alt={`Aval1DNI ${index + 1}`} style={{ width: '100%', marginBottom: '10px' }} />
                                        ))
                                    ) : (
                                        // Mostrar PDF si es desktop
                                        pdfUrlAval1 && (
                                            <iframe
                                                src={pdfUrlAval1}
                                                width="100%"
                                                height="450px"
                                                style={{ border: 'none' }}
                                            />
                                        )
                                    )}
                                </DialogContent>
                            </Dialog>
                        </Backdrop>
                    </Box>
                </Box>
            </Box>
            <Divider style={{ marginTop: 5 }} />
        </>
    );
}


